<!-- 互信息法 -->
<template>
    <div class="excavate-mutual">
        <analysisOption @option_click='option_click'> </analysisOption>
        <div class="excavate-table">
            <el-table
                :data='mutualList'
                :header-cell-style="{background:'#a7754f',color:'#fff'}"
                size='mini'
                border
                default-expand-all>
                <el-table-column
                    width="240px"
                    label="类型"
                    prop="typeName"
                >
                </el-table-column>
                <el-table-column
                    prop="description"
                    label="说明">
                    <template slot-scope="scope">
                        <div v-html='scope.row.description'></div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="btn-center">
             <el-button  type="primary" size="small" @click='mutual_click'>互信息法</el-button>
        </div>

        <!-- 分析内容 -->
        <analysisInfo   ref='analysis_info' v-if="isShowInfo" :beforeValue='beforeValue' :afterValue='afterValue'  :analysisType='"mutual"'></analysisInfo>
    </div>
</template>

<script>
import analysisOption from "./comps/analysis_option.vue"
import excavateData from './comps/excavateData.js'

import analysisInfo from './comps/analysis_info.vue'
import {mutualInformation} from '../../io/api.js'
export default {
    components: {
        analysisOption,
        analysisInfo
    },
    data () {
        return { 
            mutualList:excavateData.mutualList,
            isShowInfo:false,
            beforeRadio:'clinicalFeature',
            beforeValue:'临床表现',
            afterRadio:'clinicalFeature',
            afterValue:'临床表现',
        }
    },
    methods: {
        // 获取选择后的值
        option_click(params){
            if(params.type=='before'){
                this.beforeRadio = params.val;
                this.beforeValue=params.valName
            }else if(params.type=='after'){
                this.afterRadio = params.val;
                this.afterValue=params.valName
            }
        },
        mutual_click(){ 
            this.isShowInfo = true;
            this.$nextTick(()=>{
                this.$refs.analysis_info.filtrate_result()
            }) 
            
        }
    }
}
</script>

<style>

</style>